import './track_upgrades.scss'

// Use event delegation for robust Turbolinks compatibility
document.addEventListener('click', function(event) {
  const btn = event.target.closest('[data-track-filter-btn]')
  if (!btn) return

  const container = btn.closest('[data-track-filter="container"]')
  if (!container) return

  const filter = btn.getAttribute('data-track-filter-btn')

  // Update active button
  container.querySelectorAll('[data-track-filter-btn]').forEach(b => {
    b.classList.remove('track-upgrades__filter-btn--active')
  })
  btn.classList.add('track-upgrades__filter-btn--active')

  let visibleCount = 0

  // Filter table rows
  document.querySelectorAll('.track-upgrades__table tbody tr[data-track-status]').forEach(row => {
    const status = row.getAttribute('data-track-status')
    if (filter === 'all' || status === filter) {
      row.classList.remove('track-upgrades__row--hidden')
      visibleCount++
    } else {
      row.classList.add('track-upgrades__row--hidden')
    }
  })

  // Filter mobile cards
  document.querySelectorAll('.track-upgrades__mobile-card[data-track-status]').forEach(card => {
    const status = card.getAttribute('data-track-status')
    if (filter === 'all' || status === filter) {
      card.classList.remove('track-upgrades__row--hidden')
    } else {
      card.classList.add('track-upgrades__row--hidden')
    }
  })

  // Update count
  const countEl = container.querySelector('[data-track-filter-count]')
  if (countEl) {
    countEl.textContent = `Showing ${visibleCount} tracks`
  }
})

// Clickable rows — open certificate PDF in new tab
document.addEventListener('click', function(event) {
  const row = event.target.closest('[data-href]')
  if (!row) return

  // Don't interfere with filter button clicks
  if (event.target.closest('[data-track-filter-btn]')) return

  window.open(row.getAttribute('data-href'), '_blank')
})

